/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Preference from './Preference/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/Phones/Phone"
  
}) {
let personPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'person_phone',
path: 'number',
format: fromFormat.phoneNumberUS,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personPhoneDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'person_phone',
path: 'description',
})
let aggregateData = fromAggregate.getValueOrDefault(personPhoneDescriptionValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Phone.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="person_phone.number"
 format="/Data/format.js phoneNumberUS"
 text={personPhoneNumberValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingBottom={dtSpaceXxs}
 size="small"
 color={dtColorsNeutral500}
 data="person_phone.description"
 aggregate="/Data/aggregate.js getValueOrDefault"
 text={aggregateData}
/>
</div>
<Preference
  viewPath={`${viewPath}/Preference`}
/>
</div>
{children}
</React.Fragment>)
}